import './GraphExample.css';
import { version } from '../../../charting_library/charting_library.min';
import TVChartContainer from '../../../components/TVChartContainer';

const GraphExample = () => {
	const markets = [
		{
			"pair_key": "cctef9_usd",
			"pairs": "cctef9_usd",
			"pairsCombined": "usdcctef9",
			"pairsRevOrder": "usd_cctef9"
		}
	];
	return (
		<div className={'App'}>
			<TVChartContainer 
				theme={'light'}
				pair1={"CCTEF9"}
				pair2={'USD'}
				kline={{}}
				currentMarket={'CCTEF9_USD'}
				markets={markets}
				decimalValue={100}
				refreshExchange={false}
			/>
		</div>
	);
}

export default GraphExample;
